import { graphql, useMutation } from "react-relay";
import { useUploadImage } from "arkh";
import { useCallback } from "react";
import { useWorkspaceTodoEditAddImageMutation } from "./__generated__/useWorkspaceTodoEditAddImageMutation.graphql";

export function useWorkspaceTodoEditAddImage(id: string) {
  const [addImageMutation] = useMutation<useWorkspaceTodoEditAddImageMutation>(
    graphql`
      mutation useWorkspaceTodoEditAddImageMutation($todoId: ID!) {
        todoWorkspace(id: $todoId) {
          uploadImage {
            image {
              id
            }
            imageUploadUrl
            todoWorkspace {
              id
              ...WorkspaceTodoEditMainEditedInfo_Todo
              descriptionImages {
                id
              }
            }
          }
        }
      }
    `
  );

  const { uploadImage, prepareForImageUpload } = useUploadImage();
  const addImage = useCallback(
    async (
      uri: string,
      { width, height }: { width: number; height: number }
    ) => {
      const uploadIdRequest = prepareForImageUpload({
        width,
        height,
        localImageURI: uri,
      });
      return addImageMutation({
        onCompleted: (data) => {
          if (data.todoWorkspace?.uploadImage.imageUploadUrl) {
            uploadIdRequest.then((uploadId) => {
              uploadImage({
                imageId: data.todoWorkspace?.uploadImage.image.id,
                uploadURL: data.todoWorkspace?.uploadImage.imageUploadUrl,
                uploadId,
              });
            });
          }
        },
        variables: {
          todoId: id,
        },
      });
    },
    [addImageMutation, id, prepareForImageUpload, uploadImage]
  );

  return addImage;
}
